import type { IntervalUnit, ServiceIntervalConfig } from '../../types';

type ServiceHoursStatus =
    | { configured: false }
    | { configured: true; remaining: number; overdue: boolean; unit: IntervalUnit };

// Remaining service life in the configured unit = interval − usage, clamped to >= 0.
// Mirrors getServiceLifeRemaining but exposes the absolute countdown ("40 h to service")
// rather than the percentage shown on the rings. Overdue once usage meets the interval.
export const getServiceHoursRemaining = ({
    interval,
    usage
}: {
    interval?: ServiceIntervalConfig;
    usage: number;
}): ServiceHoursStatus => {
    if (!interval || interval.value <= 0) {
        return { configured: false };
    }

    const remaining = Math.max(0, interval.value - usage);
    const overdue = usage >= interval.value;

    return { configured: true, overdue, remaining, unit: interval.unit };
};
